import { useEffect, useMemo, useState } from "react";
import SpostItPanel from "./SpostItPanel";
import AdminDashboard from "./AdminDashboard";
import UserDashboard from "./UserDashboard";
import LandingPage from "./LandingPage";
import "./app.css";
import "./dashboard.css";
import "./governance.css";

const DEFAULT_USERS = [
  { id: "u1", name: "Paco De Maria", email: "paco@spostit.app", password: "demo1234", phone: "+39 333 123 4567", company: "SpostIt", jobTitle: "Founder & Superadmin", bio: "Creo strumenti semplici per rendere più chiara la collaborazione.", role: "Superadmin", group: "SpostIt Core", avatar: "https://i.pravatar.cc/120?img=3", status: "Attivo", notesCount: 12, lastAccess: "Oggi, 09:42" },
  { id: "u2", name: "Anna Rossi", email: "anna@spostit.app", phone: "+39 333 765 4321", company: "SpostIt", jobTitle: "Product Designer", bio: "Design, contenuti e attenzione ai dettagli.", role: "Editor", group: "Design", avatar: "https://i.pravatar.cc/120?img=5", status: "Attivo", notesCount: 8, lastAccess: "Ieri, 18:15" },
  { id: "u3", name: "Luca Bianchi", email: "luca@spostit.app", phone: "", company: "Cliente Demo", jobTitle: "Revisore", bio: "", role: "Ospite", group: "Clienti", avatar: "https://i.pravatar.cc/120?img=12", status: "Invitato", notesCount: 2, lastAccess: "Invito in attesa" },
  { id: "u4", name: "Giulia Verdi", email: "giulia@spostit.app", password: "demo1234", phone: "", company: "SpostIt", jobTitle: "Workspace Administrator", bio: "", role: "Amministratore", group: "SpostIt Core", avatar: "https://i.pravatar.cc/120?img=47", status: "Attivo", notesCount: 5, lastAccess: "Oggi, 08:20" }
];

const DEFAULT_GROUPS = [
  { id: "g1", name: "SpostIt Core", description: "Amministrazione e sviluppo", color: "#facc15", visibility: "Privato", notesCount: 12 },
  { id: "g2", name: "Design", description: "Interfaccia e contenuti", color: "#86efac", visibility: "Workspace", notesCount: 8 },
  { id: "g3", name: "Clienti", description: "Revisori esterni", color: "#f9a8d4", visibility: "Su invito", notesCount: 2 }
];

const DEFAULT_ROLES = [
  { id: "r0", name: "Superadmin", permissions: ["Tutte le funzioni", "Registro globale", "Gestisce siti", "Invia comunicazioni"] },
  { id: "r1", name: "Amministratore", permissions: ["Crea", "Modifica", "Elimina", "Gestisce utenti", "Gestisce gruppi", "Gestisce siti", "Invia comunicazioni"] },
  { id: "r2", name: "Editor", permissions: ["Crea", "Modifica", "Elimina", "Modifica profilo"] },
  { id: "r3", name: "Ospite", permissions: ["Crea", "Commenta", "Modifica profilo"] }
];

const DEFAULT_SITES = [
  { id: "s1", name: "SpostIt App", domain: "spostit.netlify.app", url: "https://spostit.netlify.app/", status: "Attivo", accessType: "group", accessIds: ["SpostIt Core", "Design"] },
  { id: "s2", name: "VeCar Digital", domain: "vecardigitalprogramming.com", url: "https://vecardigitalprogramming.com/", status: "Attivo", accessType: "group", accessIds: ["SpostIt Core", "Clienti"] }
];

const DEFAULT_MESSAGES = [
  { id: "m1", title: "Benvenuto in SpostIt", body: "Il tuo spazio di lavoro è pronto.", audienceType: "all", audienceIds: [], sender: "Paco De Maria", createdAt: "Oggi, 09:00" }
];

const DEFAULT_ACTIVITIES = [
  { id: "a1", actor: "Anna Rossi", action: "ha aggiornato uno SpostIt", target: "Homepage mobile", createdAt: "12 min fa" },
  { id: "a2", actor: "Paco De Maria", action: "ha autorizzato un sito", target: "VeCar Digital", createdAt: "1 ora fa" }
];

const normalizeUsers = stored => {
  const merged = stored.map(user => ({ ...(DEFAULT_USERS.find(item => item.id === user.id) || {}), ...user, role: user.id === "u1" ? "Superadmin" : user.role }));
  return [...merged, ...DEFAULT_USERS.filter(item => !merged.some(user => user.id === item.id))];
};
const normalizeGroups = stored => {
  const merged = stored.map(group => ({ ...(DEFAULT_GROUPS.find(item => item.id === group.id) || {}), ...group }));
  return [...merged, ...DEFAULT_GROUPS.filter(item => !merged.some(group => group.id === item.id))];
};
const normalizeRoles = stored => {
  const merged = stored.map(role => {
    const defaults = DEFAULT_ROLES.find(item => item.name === role.name);
    return defaults ? { ...defaults, ...role, permissions: [...new Set([...(defaults.permissions || []), ...(role.permissions || [])])] } : role;
  });
  return [...merged, ...DEFAULT_ROLES.filter(item => !merged.some(role => role.name === item.name))];
};

function useStoredState(key, initialValue, normalize = value => value) {
  const [value, setValue] = useState(() => {
    try { return normalize(JSON.parse(localStorage.getItem(key)) || initialValue); }
    catch { return initialValue; }
  });
  useEffect(() => localStorage.setItem(key, JSON.stringify(value)), [key, value]);
  return [value, setValue];
}

function Login({ users, onLogin }) {
  const [email, setEmail] = useState("paco@spostit.app");
  const [password, setPassword] = useState("demo1234");
  const [error, setError] = useState("");
  const submit = event => {
    event.preventDefault();
    if (!email.trim() || !password.trim()) return setError("Inserisci email e password.");
    const user = users.find(item => item.email.toLowerCase() === email.trim().toLowerCase());
    if (!user || user.status !== "Attivo" || password !== (user.password || "demo1234")) return setError("Credenziali non valide o account non attivo.");
    onLogin({ id: user.id, email: user.email });
  };
  return <main className="login-page"><section className="login-card"><div className="brand-mark">S</div><p className="eyebrow">BENVENUTO IN</p><h1>SpostIt</h1><p className="muted">Le idee rimangono esattamente dove servono.</p><form onSubmit={submit}><label>Email<input type="email" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" /></label><label>Password<input type="password" value={password} onChange={e => setPassword(e.target.value)} autoComplete="current-password" /></label>{error && <p className="form-error">{error}</p>}<button className="primary-button" type="submit">Accedi a SpostIt</button></form><p className="demo-note">Demo: puoi usare le credenziali già inserite.</p></section></main>;
}

export default function App() {
  const [session, setSession] = useStoredState("spostit-session", null);
  const [view, setView] = useState("board");
  const [users, setUsers] = useStoredState("spostit-users", DEFAULT_USERS, normalizeUsers);
  const [groups, setGroups] = useStoredState("spostit-groups", DEFAULT_GROUPS, normalizeGroups);
  const [roles, setRoles] = useStoredState("spostit-roles", DEFAULT_ROLES, normalizeRoles);
  const [sites, setSites] = useStoredState("spostit-sites", DEFAULT_SITES);
  const [messages, setMessages] = useStoredState("spostit-messages", DEFAULT_MESSAGES);
  const [activities, setActivities] = useStoredState("spostit-activities", DEFAULT_ACTIVITIES);
  useEffect(() => {
    const payload = {
      users: users.map(user => ({ id:user.id, name:user.name, email:user.email, avatar:user.avatar, role:user.role, group:user.group, status:user.status })),
      sites,
      roles
    };
    const sendConfiguration = () => window.postMessage({ source:"spostit-app", type:"SPOSIT_CONFIG_SYNC", payload }, "*");
    const receiveRequest = event => {
      if (event.source === window && event.data?.source === "spostit-extension" && event.data?.type === "SPOSIT_REQUEST_CONFIG") sendConfiguration();
    };
    window.addEventListener("message", receiveRequest);
    sendConfiguration();
    return () => window.removeEventListener("message", receiveRequest);
  }, [users, sites, roles]);
  const currentUser = useMemo(() => users.find(user => user.id === session?.id) || users.find(user => user.email === session?.email) || session, [users, session]);
  const currentRole = roles.find(role => role.name === currentUser?.role);
  const permissions = currentRole?.permissions || [];
  const isManager = ["Superadmin", "Amministratore"].includes(currentUser?.role);
  const appMode = new URLSearchParams(window.location.search).has("app");
  if (!appMode) return <LandingPage hasSession={Boolean(session)} />;
  if (!session) return <Login users={users} onLogin={setSession} />;

  return <div className="app-shell">
    <header className="topbar">
      <button className="brand" onClick={() => setView("board")}><span>S</span>SpostIt</button>
      <nav>
        <button className={view === "board" ? "active" : ""} onClick={() => setView("board")}>Bacheca</button>
        <button className={view === "me" ? "active" : ""} onClick={() => setView("me")}>Il mio spazio</button>
        {isManager && <button className={view === "admin" ? "active" : ""} onClick={() => setView("admin")}>Amministrazione</button>}
      </nav>
      <button className="profile profile-button" onClick={() => setView("me")}><img src={currentUser?.avatar} alt="" /><div><strong>{currentUser?.name}</strong><span>{currentUser?.role}</span></div></button>
      <button className="logout" onClick={() => setSession(null)}>Esci</button>
    </header>
    {view === "board" && <main className="board-home"><section><p className="eyebrow">IL TUO SPAZIO DI LAVORO</p><h1>Le idee, proprio<br />dove servono.</h1><p>Apri SpostIt e lascia una nota contestuale. Tutto il team saprà cosa fare e dove intervenire.</p><button className="primary-button" onClick={() => window.dispatchEvent(new Event("spostit:open"))}>Apri la bacheca</button></section><div className="hero-note"><span className="tape" /><div className="mini-user"><img src={currentUser?.avatar} alt="" /><strong>{currentUser?.name}</strong></div><p>Prova il nuovo SpostIt: trascinalo, cambia colore e scrivi la tua idea.</p><small>OGGI, 10:24</small></div></main>}
    {view === "me" && <UserDashboard user={currentUser} users={users} setUsers={setUsers} groups={groups} permissions={permissions} sites={sites} messages={messages} />}
    {view === "admin" && isManager && <AdminDashboard currentUser={currentUser} users={users} setUsers={setUsers} groups={groups} setGroups={setGroups} roles={roles} setRoles={setRoles} sites={sites} setSites={setSites} messages={messages} setMessages={setMessages} activities={activities} setActivities={setActivities} />}
    <SpostItPanel currentUser={currentUser} permissions={permissions} />
  </div>;
}
